const API_BASE = process.env.REACT_APP_API_URL || '';
const CLIENT_ID_KEY = 'sahkolla_client_id';

const getClientId = () => {
  if (typeof window === 'undefined' || !window.localStorage) {
    return null;
  }

  try {
    const existingId = window.localStorage.getItem(CLIENT_ID_KEY);
    if (existingId) {
      return existingId;
    }

    const generatedId = window.crypto && window.crypto.randomUUID
      ? window.crypto.randomUUID()
      : `${Date.now()}-${Math.random().toString(36).slice(2)}`;

    window.localStorage.setItem(CLIENT_ID_KEY, generatedId);
    return generatedId;
  } catch (_) {
    return null;
  }
};

export const trackNewsEvent = (newsGuid, eventType = 'open') => {
  if (!newsGuid) {
    return;
  }

  const payload = JSON.stringify({
    news_guid: newsGuid,
    event_type: eventType,
    client_id: getClientId(),
  });
  const url = `${API_BASE}/api/news/events`;

  fetch(url, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: payload,
    keepalive: true,
    credentials: 'omit',
  }).catch(() => {});
};
